import { App } from '@capacitor/app';
import { modalController } from '#imports';

export default defineNuxtPlugin(async () => {
  const platformStore = usePlatformStore();
  const deepLinkStore = useDeepLinkStore();
  const router = useRouting();

  if (platformStore.isMobile) {
    function setDeepLinkDestination(destination: string) {
      if (router.route.path == '/') {
        deepLinkStore.destination = destination;
      } else {
        if (destination.startsWith('/')) {
          router.replace(destination, true);
        } else if (destination.startsWith('#')) {
          useRouter().replace({ hash: destination });
        }
      }
    }

    async function dismissAllModals() {
      let topModal = await modalController.getTop();

      while (topModal) {
        const modalClosed = await topModal.dismiss();

        // If the user chose to decline closing a modal, stop here
        if (!modalClosed) {
          return false;
        }

        topModal = await modalController.getTop();
      }

      return true;
    }

    // Listener for handling deep links on Android and iOS
    App.addListener('appUrlOpen', async (data) => {
      const deepLinkUrl = new URL(data.url);

      switch (deepLinkUrl.pathname) {
        // Used for EKKO, we should probably just get them to migrate to universal links instead
        case '/OpenPage/TimeRegistration':
          if (!await dismissAllModals()) {
            return;
          }

          setDeepLinkDestination('/hourregistrations' + deepLinkUrl.search);
          break;

        default:
          if (deepLinkUrl.hash && deepLinkUrl.pathname.length > 1) {
            setDeepLinkDestination(deepLinkUrl.pathname + deepLinkUrl.hash);
          } else if (deepLinkUrl.pathname.length > 1) {
            setDeepLinkDestination(deepLinkUrl.pathname);
          } else if (deepLinkUrl.hash) {
            setDeepLinkDestination(deepLinkUrl.hash);
          }

          break;
      }
    });
  }
});
